import { render, staticRenderFns } from "./importError.vue?vue&type=template&id=2caf2907&scoped=true"
import script from "./importError.vue?vue&type=script&lang=js"
export * from "./importError.vue?vue&type=script&lang=js"
import style0 from "./importError.vue?vue&type=style&index=0&id=2caf2907&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caf2907",
  null
  
)

export default component.exports